// src/DesignSystem/Layout/CenteredContainer.js

import React from 'react';
import { theme } from '../../../assets/theme/theme';

export default function CenteredContainer({ children, style = {} }) {
  return (
    <div
      style={{
        width: '100%',
        maxWidth: 1240,
        margin: '0 auto',
        padding: `0 ${theme.spacing[200]}px`,
        boxSizing: 'border-box',
        ...style,
      }}
    >
      {children}
    </div>
  );
}